import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Box from '../../components/Box';
import { Helpers } from '../../helpers/Helpers';
import { RootState } from '../../redux/store';
import { KTCard } from '../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../_metronic/helpers/components/KTCardBody';
import Content from '../../_metronic/layout/components/content/Content';
import AntrepoDashboard1 from './Dashboards/AntrepoDashboard1';
import AntrepoDashboard2 from './Dashboards/AntrepoDashboard2';
import AntrepoDashboard3 from './Dashboards/AntrepoDashboard3';
import MarketingDashboard from './Dashboards/MarketingDashboard';
import ModuleDashboard from './Dashboards/ModuleDashboard';

const HomeScreen = () => {
    const auth = useSelector((state: RootState) => state.auth)
    const [activeDashboard, setActiveDashboard] = useState<string | undefined>(undefined);

    useEffect(() => {
        if (auth.user.user?.data.authorizedMenus.find(x => x.menuName.startsWith('Dashboard > ')))
            setActiveDashboard(auth.user.user?.data.authorizedMenus.filter(x => x.menuName.startsWith('Dashboard > '))[0].menuName.split('>')[1].trim())
    }, [])

    return (
        <React.Fragment>

            <Content>
                {
                    Helpers.isEmpty(activeDashboard) ?
                        (
                            <KTCard>
                                <KTCardBody>
                                    <Box flexDirection='row'>
                                        <Box justifyContent='center'>
                                            <i style={{ fontSize: 32 }} className='text-warning fa fa-exclamation-triangle' />
                                        </Box>
                                        <Box ml='15px' justifyContent='center'>
                                            <h1 className='m-0 p-0'>Seçtiğiniz şirkete tanımlı bir dashboard bulunamadı.</h1>
                                        </Box>
                                    </Box>
                                </KTCardBody>
                            </KTCard>
                        )
                        :
                        (
                            <React.Fragment>
                                <Box mb='15px' flexDirection='row' gap='15px'>
                                    {
                                        auth.user.user?.data.authorizedMenus.filter(x => x.menuName.startsWith('Dashboard > ')).map(x => x.menuName.split('>')[1].trim()).map((item, index) => (
                                            <Box onClick={() => setActiveDashboard(item)} opacity={activeDashboard == item ? undefined : '0.33'} className='actionIcon'>
                                                <KTCard>
                                                    <Box p='15px'>
                                                        <h5 className='m-0 p-0'>{item}</h5>
                                                    </Box>
                                                </KTCard>
                                            </Box>
                                        ))
                                    }
                                </Box>

                                {activeDashboard == 'Antrepo' && <AntrepoDashboard1 />}
                                {activeDashboard == 'Pazarlama' && <MarketingDashboard />}
                                {activeDashboard == 'Antrepo Dashboard 2' && <AntrepoDashboard2 />}
                                {activeDashboard == 'Antrepo Dashboard 3' && <AntrepoDashboard3 />}
                                {activeDashboard == 'Yurtiçi Kargo' && <ModuleDashboard module='YURTICI_CARGO' />}
                                {activeDashboard == 'Nakliye' && <ModuleDashboard module='AMBAR' />}
                            </React.Fragment>
                        )
                }


            </Content >
        </React.Fragment >
    )
}

export default HomeScreen;